module.exports = __webpack_public_path__ + "static/media/SWSCRC6-34.d0464480.mp3";